import { createFileRoute } from "@tanstack/react-router";
import { ArrowRight } from "@untitledui/icons";
import { EmptyValue } from "@/components/common/EmptyValue";
import { useAppTranslation } from "@/hooks/use-app-translation";
import { getLifecycleTransitions } from "@/utils/lifecycle-detail/lifecycle-detail.utils";
import { useLifecycleDrawerContext } from "@/utils/lifecycle-detail/lifecycle-drawer-context";
import { resolveStatusCategoryColors } from "@/utils/status-category-colors";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/lifecycles/$lifecycleId/transitions",
)({
	component: LifecycleTransitionsTabContent,
});

function LifecycleTransitionsTabContent() {
	const { t } = useAppTranslation();
	const { lifecycle } = useLifecycleDrawerContext();
	const transitions = getLifecycleTransitions(lifecycle);

	return (
		<div className="space-y-4 px-5 pb-5">
			<div>
				<h3 className="text-lg font-semibold text-[16px] text-primary">
					{t("admin.lifecycles.drawer.transitions.title")}
				</h3>
				<p className="text-sm text-gray-500">
					{t("admin.lifecycles.drawer.transitions.description")}
				</p>
			</div>
			<div className="rounded-lg border border-gray-200 bg-gray-50 p-6">
				{transitions.length === 0 ? (
					<div className="py-8 text-center text-sm text-gray-500">
						{t("admin.lifecycles.drawer.transitions.empty")}
					</div>
				) : (
					<div className="space-y-3">
						{transitions.map((transition, index) => {
							const from = resolveStatusCategoryColors(
								transition.fromStatus?.statusCategoryIconColor ??
									transition.fromStatus?.statusCategory?.iconColor,
							);
							const to = resolveStatusCategoryColors(
								transition.toStatus?.statusCategoryIconColor ??
									transition.toStatus?.statusCategory?.iconColor,
							);
							return (
								<div
									key={`${transition.fromStatus?.id ?? "from"}-${transition.toStatus?.id ?? "to"}-${index}`}
									className="flex items-center gap-3 rounded-lg border border-gray-200 bg-white p-3"
								>
									<span
										className="inline-flex items-center rounded-full border px-2 py-0.5 text-xs"
										style={{
											backgroundColor: from.bgColor,
											borderColor: from.color,
										}}
									>
										{transition.fromStatus?.name || <EmptyValue />}
									</span>
									<ArrowRight className="size-4 text-gray-400" />
									<span
										className="inline-flex items-center rounded-full border px-2 py-0.5 text-xs"
										style={{
											backgroundColor: to.bgColor,
											borderColor: to.color,
										}}
									>
										{transition.toStatus?.name || <EmptyValue />}
									</span>
								</div>
							);
						})}
					</div>
				)}
			</div>
		</div>
	);
}
